import React from "react";
import Modal from "../../components/Modal";
import SpocTable from "./Components/SpocTable";
import AddNewSpocModal from "./Components/AddNewSpoc";
import { useSpocManagement } from "./SpocManagementData";
import "./index.scss";

// import { validateEmail, validateMobile } from "../../utils/validationUtils";

const SpocManagement = () => {
  const {
    spocList,
    loading,
    searchQuery,
    handleSearchChange,
    // add/edit/view modal
    modalOpen,
    modalMode,
    formData,
    formErrors,
    saving,
    openAddModal,
    openViewModal,
    openEditModal,
    closeModal,
    handleFieldChange,
    handleDeptToggle,
    handleSubmit,
    // status modal
    statusModalOpen,
    statusTarget,
    statusValue,
    setStatusValue,
    statusLoading,
    openStatusModal,
    closeStatusModal,
    handleStatusSubmit,
  } = useSpocManagement();

  return (
    <div className="spoc-page">
      {/* Page header */}
      <div className="spoc-header">
        <div>
          <h1 className="spoc-header__title">SPOC Management</h1>
          <p className="spoc-header__sub">
            Manage Single Point of Contact users
            {spocList.length > 0 && (
              <span className="spoc-header__count">
                {" "}
                · {spocList.length} record{spocList.length !== 1 ? "s" : ""}
              </span>
            )}
          </p>
        </div>
        <button className="spoc-add-btn" onClick={openAddModal}>
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Add New SPOC
        </button>
      </div>

      {/* Search bar */}
      <div className="spoc-search-wrap">
        <div className="spoc-search">
          <svg
            className="spoc-search__icon"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            type="text"
            className="spoc-search__input"
            placeholder="Search by name, employee id..."
            value={searchQuery}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
          {searchQuery && (
            <button
              className="spoc-search__clear"
              onClick={() => handleSearchChange("")}
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div className="spoc-loading">Loading SPOC list…</div>
      ) : (
        <SpocTable
          data={spocList}
          onView={openViewModal}
          onEdit={openEditModal}
          onToggleStatus={openStatusModal}
        />
      )}

      {/* Add / Edit / View modal */}
      <AddNewSpocModal
        isOpen={modalOpen}
        onClose={closeModal}
        mode={modalMode}
        formData={formData}
        formErrors={formErrors}
        saving={saving}
        onChange={handleFieldChange}
        onDeptToggle={handleDeptToggle}
        onSubmit={handleSubmit}
      />

      {/* Change Status Modal — same pattern as ParentCode */}
      <Modal
        isOpen={statusModalOpen}
        onClose={closeStatusModal}
        title={statusValue ? "Deactivate SPOC" : "Activate SPOC"}
        size="small"
      >
        <div className="pc-status-modal">
          {/* Entity info strip */}
          <div className="pc-status-modal__info">
            <div className="pc-status-modal__avatar">
              {(statusTarget?.employeeName || "?")[0].toUpperCase()}
            </div>
            <div className="pc-status-modal__info-text">
              <p className="pc-status-modal__entity-name">
                {statusTarget?.employeeName || "—"}
              </p>
              <p className="pc-status-modal__entity-id">
                {statusTarget?.employeeId} · {statusTarget?.email}
              </p>
            </div>
          </div>

          <div className="pc-status-modal__divider" />

          {/* Toggle section */}
          <div className="pc-status-modal__section">
            <p className="pc-status-modal__section-label">Active Status</p>
            <p className="pc-status-modal__section-hint">
              Toggle to set whether this SPOC account is active or inactive.
            </p>

            <div className="pc-status-modal__toggle-wrap">
              <button
                className={`pc-status-option ${!statusValue ? "pc-status-option--inactive" : ""}`}
                onClick={() => setStatusValue(false)}
              >
                <span className="pc-status-option__dot" />
                Inactive
              </button>

              <button
                className={`pc-toggle ${statusValue ? "pc-toggle--on" : "pc-toggle--off"}`}
                onClick={() => setStatusValue((v) => !v)}
                aria-label="Toggle active status"
              >
                <span className="pc-toggle__thumb" />
              </button>

              <button
                className={`pc-status-option ${statusValue ? "pc-status-option--active" : ""}`}
                onClick={() => setStatusValue(true)}
              >
                <span className="pc-status-option__dot" />
                Active
              </button>
            </div>
          </div>

          {/* Actions */}
          <div className="pc-status-modal__actions">
            <button
              className="pc-status-modal__btn-cancel"
              onClick={closeStatusModal}
              disabled={statusLoading}
            >
              Cancel
            </button>
            <button
              className="pc-status-modal__btn-confirm"
              onClick={handleStatusSubmit}
              disabled={statusLoading}
            >
              {statusLoading && <span className="pc-status-modal__spinner" />}
              {statusLoading ? "Saving…" : "Confirm"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SpocManagement;
